/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { ProductsLikeCreateData, ProductsLikeCreateStatus200 } from "../types/ProductsLikeCreate.ts";

function getProductsLikeCreateUrl() {
	const res = { method: "POST", url: `/api/products/like/` as const };

	return res;
}

/**
 * @description Обновление лайка к продукту.
 * @summary обновление лайка у продукта
 * {@link /api/products/like/}
 */
export async function productsLikeCreate(
	data: ProductsLikeCreateData,
	config: Partial<RequestConfig<ProductsLikeCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<ProductsLikeCreateStatus200, ResponseErrorConfig<Error>, ProductsLikeCreateData>({
		method: "POST",
		url: getProductsLikeCreateUrl().url.toString(),
		data: requestData,
		contentType,
		...requestConfig,
	});

	return res.data;
}
